import axios from 'axios';
const img_url = 'https://imgcdn.xinchongjia.com/';//图片地址域名

let api_url = 'https://api.test.xinchongjia.com';
let upload_img_url = 'https://api.test.xinchongjia.com/api/FileCloud/Upload';
let bms_url = 'https://bms.test.xinchongjia.com';
let version = '2.0.1';
if (process.env.NODE_ENV == 'production') {
    api_url = 'https://api.xinchongjia.com';
    upload_img_url = 'https://api.xinchongjia.com/api/FileCloud/Upload';
    bms_url = 'https://bms.xinchongjia.com';
    version = '2.0.1'
} else if (process.env.NODE_ENV == 'deployelopment') {
    api_url = 'http://api.localhost.com';
    upload_img_url = 'http://api.localhost.xinchongjia.com/api/FileCloud/Upload';
    bms_url = 'http://bms.localhost.com';
    api_url = 'http://api.localhost.xinchongjia.com/';
    api_url = 'https://api.test.xinchongjia.com/'
    api_url = 'http://v3.api.xcj.com/';
    api_url = 'http://192.168.30.215/';
    version = '2.0.2'
}


export default {
    img_url,
    api_url,
    upload_img_url,
    bms_url,
    version,
}




// WEBPACK FOOTER //
// ./src/api/config.js